import axios from 'axios';
import canvasSize from 'canvas-size';
import html2pdf from 'html2pdf.js';
import * as FileSaver from 'file-saver';
// import JSZip from 'jszip';

export function downloadHtmlToFile({
  fileName,
  ref,
  url = '',
  catchCallback,
  finallyCallback,
  thenCallback,
  config = {},
}: {
  fileName: string;
  ref: any;
  url?: string;
  catchCallback?: () => void;
  finallyCallback?: () => void;
  thenCallback?: () => void;
  config?: any;
}) {
  let isValidCanvas = true;

  const clone = ref.current?.cloneNode(true) as HTMLElement;

  clone?.querySelectorAll?.('details')?.forEach((detail) => {
    if (!detail.hasAttribute('open')) {
      const summaryElement = detail.querySelector('summary');
      if (summaryElement) {
        // 如果存在 summary，则使用其内容
        detail.innerHTML = `<summary>${summaryElement.innerHTML}</summary>`;
      } else {
        // 如果不存在 summary，则创建一个空的 summary
        detail.innerHTML = `<summary></summary>`;
      }
    }
  });

  const worker = html2pdf()
    .set({
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
        before: '.dbo-page-break', // 指定分页类名
      },
      thenExternal: () => {
        console.log(isValidCanvas);
      },
      html2canvas: {
        scale: 2,
        useCORS: true,
        async onrendered(canvas: { width: any; height: any }) {
          isValidCanvas = canvasSize.test({
            width: canvas.width,
            height: canvas.height,
          });

          if (isValidCanvas) {
            worker
              .toImg()
              .toPdf()
              .save(`${fileName}.pdf`)
              .then(() => {
                thenCallback?.();
              });
          } else {
            axios
              .get(url, { responseType: 'blob' })
              .then((res) => {
                if (res?.data) {
                  FileSaver.saveAs(res.data, `${fileName}.md`);
                }
                thenCallback?.();
              })
              .catch(() => catchCallback?.())
              .finally(() => finallyCallback?.());
          }
        },
      },
      margin: [0, 10, 0, 10],
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }, // jsPDF 配置
      image: { type: 'jpeg', quality: 1 },
      ...config,
    })
    .from(clone)
    .toCanvas();
}

export function saveFileAs(content: Blob, fileName: string) {
  try {
    // 触发下载
    const url = URL.createObjectURL(content);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    // 清理
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    throw error;
  }
}

function isBlob(data: any): data is Blob {
  return data instanceof Blob;
}

export async function downloadZip(
  fileData: Array<{ fileName: string; data: string | Blob | ArrayBuffer }>,
  fileName: string,
) {
  try {
    const JSZip = await import('jszip');
    let zip = new JSZip.default();

    for (let i = 0; i < fileData.length; i++) {
      const { fileName, data } = fileData[i];
      if (isBlob(data)) {
        const buffer = await data?.arrayBuffer();
        zip.file(fileName, buffer);
      } else {
        zip.file(fileName, data);
      }
    }

    const zipBlob = await zip.generateAsync({
      type: 'blob',
      compression: 'DEFLATE',
    });

    saveFileAs(zipBlob, `${fileName}.zip`);
  } catch (error) {
    throw error;
  }
}
